import { backendHighlights } from "../../Object Files/profile";
import "./highlights.css";

const Highlights = () => {
  return (
    <section id="expertise" className="highlights-section" aria-label="Backend expertise">
      <div className="highlights-inner max-width">
        <p className="highlights-eyebrow alt-text">What I bring to your team</p>
        <h2 className="highlights-title">Backend engineering that ships</h2>
        <ul className="highlights-grid">
          {backendHighlights.map((item) => (
            <li key={item.id} className="highlight-card">
              <span className="highlight-icon" aria-hidden="true">
                <i className={item.icon}></i>
              </span>
              <h3>{item.title}</h3>
              <p>{item.detail}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Highlights;
